// Iconos SVG inline para Couriers XL.
// Migrado desde modules/couriers/components/Icons.jsx sin cambios funcionales.
// Heredan currentColor; el color final lo define el padre via tokens.

export function IconTruck({ className }) {
  return (
    <svg className={className} width="18" height="18" viewBox="0 0 24 24"
      fill="none" stroke="currentColor" strokeWidth="2"
      strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="1" y="3" width="15" height="13" />
      <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
      <circle cx="5.5" cy="18.5" r="2.5" />
      <circle cx="18.5" cy="18.5" r="2.5" />
    </svg>
  );
}

export function IconPlus({ className }) {
  return (
    <svg className={className} width="16" height="16" viewBox="0 0 24 24"
      fill="none" stroke="currentColor" strokeWidth="2"
      strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  );
}

export function IconSparkles({ className }) {
  return (
    <svg className={className} width="14" height="14" viewBox="0 0 24 24"
      fill="none" stroke="currentColor" strokeWidth="2"
      strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M12 3v4M12 17v4M5 12H1m22 0h-4M6 6l-2-2m14 14l2 2M6 18l-2 2m14-14l2-2" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}
